import FractionDsnEntite from '@/generated/controls/fractionDsn/FractionDsnEntite.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: FractionDsnEntite
})
